export const DOUBLE_HEIGHT_KEYS: number[] = [80, 115];
